import React from "react";
import { Typography, Box } from "..";
import { ItemActionTimeInfoProps } from "./ItemActionTimeInfo.types";
import { formatInfo } from "./ItemActionTimeInfoHelper";

function ItemActionTimeInfo(props: ItemActionTimeInfoProps) {
  const { actions, dateFormat, highlight, ...other } = props;

  const info = actions?.map((a, index) => {
    const value = formatInfo(a, dateFormat);
    return (
      value && (
        <Typography key={index} color="grey" tone={700} variant="body3">
          {index > 0 ? ` (${value})` : value}
        </Typography>
      )
    );
  });

  return <Box {...other}>{info}</Box>;
}

export default ItemActionTimeInfo;
